<template>
    <div class="relative">
        <div class="absolute -mt-1 md:-mt-6 pl-1 md:pl-3">
            <i class="text-sm text-green-warm-500 fas fa-minus"></i>
        </div>

        <form-row title="Referral Fees Paid"
            :no_border="true"
            class="mt-6 md:-mt-2 mb-6"
            label_class="ml-8 md:ml-0"
        >
            <div class="flex-wrap flex flex-1 items-center mt-0">
                <div class="w-1/2 sm:w-1/4 pr-3 sm:pr-6">
                    <input-percent
                        label="To Broker"
                        name="list_side_referral_fee_broker_percent"
                        v-model="referral_fee_broker_percent"
                        placeholder="Fee"
                        :read_only="read_only"
                    />
                </div>

                <div class="w-1/2 sm:w-1/4 pl-3 sm:pl-0 sm:pr-6">
                    <input-percent
                        label="To Re-lo"
                        name="list_side_referral_fee_relo_percent"
                        v-model="referral_fee_relo_percent"
                        placeholder="Fee"
                        :read_only="read_only"
                    />
                </div>

                <div class="mt-6 sm:mt-0 flex-1 sm:pl-10">
                    <input-money
                        label="Total Referral Fees Paid"
                        name="list_side_referral_fee_total"
                        :value="referral_fee_total_formatted"
                        tabindex="-1"
                        :read_only="true"
                    />
                </div>
            </div>
        </form-row>

        <div class="border-b border-gray-400 md:ml-46 mb-6"></div>
    </div>
</template>

<script>
import MoneyFunctions from '../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    props: {
        commission_detail: { default: () => ({}) },
        fee: {},
        read_only: { default: false },
    },

    data() {
        return {
            referral_fee_broker_percent: this.commission_detail.list_side_referral_fee_broker_percent,
            referral_fee_relo_percent: this.commission_detail.list_side_referral_fee_relo_percent,
        }
    },

    computed: {
        broker_referral_fee() {
            return (this.referral_fee_broker_percent / 100) * this.fee;
        },
        relo_referral_fee() {
            return (this.referral_fee_relo_percent / 100) * this.fee;
        },
        referral_fee_total_value() {
            return this.moneyVal(this.broker_referral_fee)
                + this.moneyVal(this.relo_referral_fee);
        },
        referral_fee_total_formatted() {
            return this.formatMoney(this.referral_fee_total_value);
        },
    },

    watch: {
        referral_fee_total_value(value) {
            this.$emit('updated', value);
        },
    },
}
</script>
